var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDownFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3024 13.3201C9.90744 13.3201 9.52965 13.1382 9.26737 12.819L5.97881 8.8396C5.5854 8.36267 5.50656 7.68591 5.77664 7.11375C6.01471 6.60871 6.48852 6.29492 7.01385 6.29492H13.591C14.1163 6.29492 14.5901 6.60871 14.8282 7.11375C15.0983 7.68591 15.0194 8.36267 14.6268 8.83882L11.3375 12.819C11.0752 13.1382 10.6974 13.3201 10.3024 13.3201Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2721_16302",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 10,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3024 13.3201C9.90744 13.3201 9.52965 13.1382 9.26737 12.819L5.97881 8.8396C5.5854 8.36267 5.50656 7.68591 5.77664 7.11375C6.01471 6.60871 6.48852 6.29492 7.01385 6.29492H13.591C14.1163 6.29492 14.5901 6.60871 14.8282 7.11375C15.0983 7.68591 15.0194 8.36267 14.6268 8.83882L11.3375 12.819C11.0752 13.1382 10.6974 13.3201 10.3024 13.3201Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2721_16302)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownFill);
export default __webpack_public_path__ + "static/media/arrow-down-fill.9d454211beb97bb2ef9c6ad6d414776e.svg";
export { ForwardRef as ReactComponent };